import React, { Component } from "react";
import Navbar from '../../commons/components/navbar';
import Header from './components/header';
import InvalidHash from './container/invalidHash';
import FormFirstStep from './container/formFirstStep';
import FormFirstStepCpf from './container/formFirstStepCpf';
import FormSecondStep from './container/formSecondStep';
import EmailAlreadyExists from './container/emailAlreadyExists';
import RegisterSuccess from './container/registerSuccess';
import CpfNotFound from './container/cpfNotFound';
import CpfAlreadyRegistered from "./container/cpfAlreadyRegistered";
import { withRouter } from 'react-router-dom';
import {
    loadCompanyDetails,
    verifyEmailService,
    registerUserIntoDepartment,
    verifyCpfService,
    CpfNotFoundException,
    CpfAlreadyRegisteredException, registerUserByCpf
} from "../../services/httpServices";
class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: false,
            step: 0,
            modal: false,
            company: {},
            person: {},
            invalidHash: false
        };
        this.toggle = this.toggle.bind(this);
        this.verifyEmail = this.verifyEmail.bind(this);
        this.submitProfileData = this.submitProfileData.bind(this);
        this.clickToBack = this.clickToBack.bind(this);
        this.verifyRegistrationType = this.verifyRegistrationType.bind(this);
    }

    componentWillMount() {
        loadCompanyDetails(this.props.match.params.hash, this.verifyRegistrationType())
            .then(response => {
                console.log('loadCompanyDetails', response)

                this.setState({
                    company: {
                        name: response.data.companyName,
                        department: response.data.departmentName,
                        companyId: response.data.companyId,
                        image: response.data.companyImage,
                        departmentId: response.data.departmentId
                    },
                    loading: false
                })
            }).catch(e => {
                console.log('Invalid hash', e)
                this.setState({invalidHash: true, error: true, loading: false})
            });
    }

    verifyRegistrationType(){
        return document.location.href.includes('isCpfValidation');
    }

    verifyEmail(e) {
        e.preventDefault();
        this.setState({
            loading: true,
            person: {
                email: e.target.email.value
            }
         });

        verifyEmailService(e.target.email.value, this.state.company.companyId, this.state.company.departmentId)
          .then((response) => {
              console.log('verifyEmailService', response)
              this.setState({
                  error: false,
                  step: 1,
                  loading: false,
                  person: {
                      ...this.state.person,
                      id: response.data.userId
                  }
              })
          })
          .catch((err) => {
              this.setState({
                  error: true,
                  loading: false,
                  emailAlreadyRegistered: true
               })
          });
    }

    verifyCpf = (e) => {
        e.preventDefault();

        const cpf = e.target.cpf.value.replace(/\./g, '').replace('-', '');

        this.setState({
            loading: true,
            person: {
                cpf: cpf
            }
        });

        verifyCpfService(cpf, this.state.company.companyId, this.state.company.departmentId)
          .then((response) => {
              console.log('verifyEmailService', response)
              this.setState({
                  error: false,
                  step: 1,
                  loading: false,
                  person: {
                      ...this.state.person,
                      id: response.data.userId
                  },
                  isCpfRegister: true
              })
          })
          .catch((err) => {
              if (err instanceof CpfNotFoundException) {
                  this.setState({
                      error: true,
                      cpfNotFound: true,
                      loading: false
                  })
              } else if (err instanceof CpfAlreadyRegisteredException) {
                  this.setState({
                      error: true,
                      cpfAlreadyRegistered: true,
                      loading: false
                  })
              }
          });
    }

    submitProfileData(e) {
        e.preventDefault();
        if (this.state.isCpfRegister) {
            this.setState({
                modal: true,
                person: {
                    ...this.state.person,
                    name: e.target.name.value,
                    phone: e.target.phone.value,
                    email: e.target.email.value
                }
            });
        } else {
            this.setState({
                modal: true,
                person: {
                    ...this.state.person,
                    name: e.target.name.value,
                    phone: e.target.phone.value,
                    cpf: e.target.cpf.value.replace(/\D/g,'')
                }
            });
        }
    }

    toggle(e) {
        this.setState({
            modal: !this.state.modal
        });
    }

    registerEmployee = (e) => {
        e.preventDefault();
        registerUserIntoDepartment(
          this.state.person.name,
          this.state.person.email,
          this.state.person.phone,
          this.state.company.companyId,
          this.state.company.departmentId,
          this.state.person.cpf,
        )
        .then(response => {
            console.log('registerUserIntoDepartment', response)
            this.setState({
                step: 2,
                modal: false
            })
        }).catch(error => {
            if(error.response.status == 409){
                this.setState({cpfAlreadyRegistered: true, modal: false})
            }
            console.log('ERROR registerUserIntoDepartment', error)
        });
    }

    registerEmployeeByCpf = (e) => {
        e.preventDefault();
        registerUserByCpf(
          this.state.person.name,
          this.state.person.email,
          this.state.person.phone,
          this.state.company.companyId,
          this.state.person.id
        )
          .then(response => {
              console.log('registerUserIntoDepartment', response)
              this.setState({
                  step: 2,
                  modal: false
              })
          }).catch(error => {
            if(error.response.status == 409){
                this.setState({emailAlreadUsed: true, modal: false})
            }
            console.log('ERROR registerUserIntoDepartment', error)
        });
    }

    clickToBack(e) {
        this.setState({
            step: this.state.step - 1
        })
    }
    
    clickToReload = () => {
        window.location.reload()
    }

    render() {
        let OS = navigator.appVersion;
        return (
            <div>
                <Navbar
                    step={this.state.step}
                    error={this.state.error}
                    clickToReload={this.clickToReload}
                    clickToBack={this.clickToBack}/>
                {
                    this.state.step !== 2 && !this.state.loading &&
                <Header
                    location={this.state.company.name}
                    inviterUrlPic={this.state.company.image}
                    isCpfRegister={this.state.isCpfRegister}/>
                }
                {
                    this.state.loading && <h1 className={'loading'}>Carregando...</h1>
                }
                {
                    this.state.step === 0 && this.state.invalidHash &&
                    <InvalidHash/>
                }
                {
                    this.state.step === 0 && !this.state.invalidHash && !this.state.loading && !this.state.error && !this.verifyRegistrationType() &&
                    <FormFirstStep departmentName={this.state.company.department} onSubmit={this.verifyEmail} isCpfRegister={this.state.isCpfRegister}/>
                }
                {
                    this.state.step === 0 && !this.state.invalidHash && !this.state.loading && !this.state.error && this.verifyRegistrationType() &&
                    <FormFirstStepCpf companyName={this.state.company.name} onSubmit={this.verifyCpf}/>
                }
                {
                    this.state.step === 0 && !this.state.invalidHash && !this.state.loading && this.state.error && this.state.cpfNotFound &&
                    <CpfNotFound
                      os={OS}
                      company={this.state.company.name}
                    />
                }
                {
                    this.state.step === 0 && !this.state.invalidHash && !this.state.loading && this.state.error && this.state.cpfAlreadyRegistered &&
                    <CpfAlreadyRegistered
                      os={OS}
                      department={this.state.company}
                    />
                }
                {
                    this.state.step === 0 && !this.state.invalidHash && !this.state.loading && this.state.error && this.state.emailAlreadyRegistered &&
                    <EmailAlreadyExists
                      os={OS}
                      department={this.state.company.department}
                    />
                }
                {
                    this.state.step === 1 && !this.state.loading && !this.state.error &&
                    <FormSecondStep
                        submitForm={this.submitProfileData}
                        toggle={this.toggle}
                        modal={this.state.modal}
                        companyName={this.state.company.name}
                        departmentName={this.state.company.department}
                        locationModal={this.state.company.name}
                        confirmModal={this.state.isCpfRegister ? this.registerEmployeeByCpf : this.registerEmployee}
                        isCpfRegister={this.state.isCpfRegister}
                        alreadyRegisteredCpf={this.state.cpfAlreadyRegistered}
                        emailAlreadUsed={this.state.emailAlreadUsed}
                    />
                }
                {
                    this.state.step === 2 && !this.state.loading && !this.state.error &&
                    <RegisterSuccess
                        departmentName={this.state.company.department}
                        isCpfRegister={this.state.isCpfRegister}
                        os={OS}
                    />
                }
            </div>
        )
    }
}
export default withRouter(HomePage);




// WEBPACK FOOTER //
// ./src/app/home/home.screen.js